import React from "react";
import { useWeddingData } from "../hooks/useWeddingData";
import "./InvitationSection.css";

const InvitationSection: React.FC = () => {
  const { weddingData, loading } = useWeddingData();

  const formatWeddingDate = (dateString: string, timeString: string) => {
    if (!dateString || !timeString) {
      return { date: "날짜", time: "시간" };
    }

    try {
      // 날짜 형식 처리 (YYYY-MM-DD 또는 다른 형식)
      let year, month, day;

      if (dateString.includes("-")) {
        [year, month, day] = dateString.split("-").map(Number);
      } else if (dateString.includes("/")) {
        [year, month, day] = dateString.split("/").map(Number);
      } else {
        // 다른 형식의 날짜 처리
        const date = new Date(dateString);
        year = date.getFullYear();
        month = date.getMonth() + 1;
        day = date.getDate();
      }

      // 요일 계산
      const dateObj = new Date(year, month - 1, day);
      const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
      const weekday = weekdays[dateObj.getDay()];

      // 시간 형식 처리 (HH:MM 또는 다른 형식)
      let hours, minutes;

      if (timeString.includes(":")) {
        [hours, minutes] = timeString.split(":").map(Number);
      } else {
        // 시간이 숫자로만 되어있는 경우
        hours = parseInt(timeString);
        minutes = 0;
      }

      const ampm = hours >= 12 ? "오후" : "오전";
      const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;

      return {
        date: `${year}년 ${month}월 ${day}일 (${weekday})`,
        time: `${ampm} ${displayHours}시 ${minutes}분`,
      };
    } catch (error) {
      console.error("Error formatting date:", error);
      return { date: "날짜", time: "시간" };
    }
  };

  if (loading || !weddingData) {
    return <div className="invitation-section loading">로딩 중...</div>;
  }

  const formattedDate = formatWeddingDate(
    weddingData.date || "",
    weddingData.time || ""
  );

  return (
    <section className="invitation-section">
      <div className="invitation-content">
        <div className="invitation-header">
          <h2 className="section-title">초대합니다</h2>
        </div>

        <div className="invitation-message">
          {weddingData.invitationMessage ? (
            weddingData.invitationMessage
              .split("\n")
              .map((line, index) => <p key={index}>{line}</p>)
          ) : (
            <p>초대 메시지가 준비 중입니다.</p>
          )}
        </div>

        <div className="couple-info">
          <div className="couple-line">
            <span className="parents">
              <strong>{weddingData.groom?.fatherName || "아버지"}</strong> · <strong>{weddingData.groom?.motherName || "어머니"}</strong>의 아들 <strong>{weddingData.groom?.name || "신랑"}</strong>
            </span>
          </div>

          <div className="couple-line">
            <span className="parents">
              <strong>{weddingData.bride?.fatherName || "아버지"}</strong> · <strong>{weddingData.bride?.motherName || "어머니"}</strong>의 딸 <strong>{weddingData.bride?.name || "신부"}</strong>
            </span>
          </div>
        </div>
        {/* 드레스 코드 안내 (컬러 강조) */}
        <div
          style={{
            margin: "1.2rem auto 0 auto",
            fontWeight: 500,
            color: "#6b4e71",
            fontSize: "1.22rem",
            textAlign: "center",
          }}
        >
          드레스 코드:{" "}
          <span style={{ color: "#111", fontWeight: 700 }}>블랙</span>
          <span style={{ fontWeight: 400, margin: "0 2px" }}>&amp;</span>
          <span style={{ color: "#e74c3c", fontWeight: 700 }}>레드</span>
          <span style={{ marginLeft: 6, fontSize: "1.1em" }}>🖤❤️</span>
        </div>
      </div>
    </section>
  );
};

export default InvitationSection;
